import { render, staticRenderFns } from "./RegionInfoOverlay.vue?vue&type=template&id=6bfdfda0"
import script from "./RegionInfoOverlay.vue?vue&type=script&lang=js"
export * from "./RegionInfoOverlay.vue?vue&type=script&lang=js"
import style0 from "./RegionInfoOverlay.vue?vue&type=style&index=0&id=6bfdfda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports